var cov_x3kvlfs72 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Menu/List.tsx",
      hash = "e4b9513ea97c577d9fd99aaa9931109c238ed4db",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Menu/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 18
        }
      },
      "1": {
        start: {
          line: 33,
          column: 23
        },
        end: {
          line: 33,
          column: 53
        }
      },
      "2": {
        start: {
          line: 34,
          column: 22
        },
        end: {
          line: 34,
          column: 105
        }
      },
      "3": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 64,
          column: 5
        }
      },
      "4": {
        start: {
          line: 39,
          column: 10
        },
        end: {
          line: 61,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 11
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 38,
            column: 19
          }
        },
        loc: {
          start: {
            line: 39,
            column: 10
          },
          end: {
            line: 61,
            column: 12
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 51
          },
          end: {
            line: 34,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 64
          },
          end: {
            line: 34,
            column: 74
          }
        }, {
          start: {
            line: 34,
            column: 77
          },
          end: {
            line: 34,
            column: 81
          }
        }],
        line: 34
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Menu/List.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { getKey } from '../utils/uid';
import { menuClass } from './styles';
import Item from './Item';

var List =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  var _super = _createSuper2(List);

  function List() {
    _classCallCheck(this, List);

    return _super.apply(this, arguments);
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this = this;

      cov_x3kvlfs72.f[0]++;

      var _ref = (cov_x3kvlfs72.s[0]++, this.props),
          data = _ref.data,
          path = _ref.path,
          mode = _ref.mode,
          style = _ref.style,
          level = _ref.level,
          keygen = _ref.keygen,
          topLine = _ref.topLine,
          onClick = _ref.onClick,
          linkKey = _ref.linkKey,
          disabled = _ref.disabled,
          renderItem = _ref.renderItem,
          frontCaret = _ref.frontCaret,
          bottomLine = _ref.bottomLine,
          caretColor = _ref.caretColor,
          inlineIndent = _ref.inlineIndent,
          looseChildren = _ref.looseChildren,
          frontCaretType = _ref.frontCaretType,
          toggleOpenKeys = _ref.toggleOpenKeys,
          toggleDuration = _ref.toggleDuration,
          parentSelectable = _ref.parentSelectable;

      var isVertical = (cov_x3kvlfs72.s[1]++, mode.indexOf('vertical') === 0);
      var className = (cov_x3kvlfs72.s[2]++, classnames(menuClass('list', isVertical ? (cov_x3kvlfs72.b[0][0]++, 'vertical') : (cov_x3kvlfs72.b[0][1]++, mode)), this.props.className));
      cov_x3kvlfs72.s[3]++;
      return (
        /*#__PURE__*/
        React.createElement("ul", {
          className: className,
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 37,
            columnNumber: 7
          }
        }, data.map(function (d, i) {
          cov_x3kvlfs72.f[1]++;
          cov_x3kvlfs72.s[4]++;
          return (
            /*#__PURE__*/
            React.createElement(Item, {
              data: d,
              index: i,
              mode: mode,
              path: path,
              level: level,
              keygen: keygen,
              onClick: onClick,
              linkKey: linkKey,
              topLine: topLine,
              disabled: disabled,
              frontCaret: frontCaret,
              caretColor: caretColor,
              bottomLine: bottomLine,
              renderItem: renderItem,
              key: getKey(d, keygen, i),
              inlineIndent: inlineIndent,
              looseChildren: looseChildren,
              toggleOpenKeys: toggleOpenKeys,
              toggleDuration: toggleDuration,
              frontCaretType: frontCaretType,
              parentSelectable: parentSelectable,
              __self: _this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 39,
                columnNumber: 11
              }
            })
          );
        }))
      );
    }
  }]);

  return List;
}(PureComponent);

export default List;